import { action, observable } from 'mobx';

import { FormStore } from '@estee/elc-form';

import { RampFormValidator } from './RampFormValidator';

export enum MessageVariant {
    ERROR = 'error',
    INFO = 'info'
}

interface IFormMessage {
    variant: MessageVariant;
    translationKey?: string;
    content?: string;
}

export class RampFormStore<T> extends FormStore<T> {
    // TODO: APACRIGEL-1199 currently not in use
    @observable messages: IFormMessage[] = [];
    @observable isSubmitting: boolean = false;

    constructor(initialValues: T) {
        super({
            initialValues,
            formValidator: new RampFormValidator()
        });
    }

    public validateForm = () => {
        Object.keys(this.errors).forEach((fieldName) => {
            this.setTouchedField(fieldName as keyof T);
        });
    };

    @action
    public setMessage = (message: IFormMessage) => (this.messages = [message]);

    @action
    public setMessages = (messages: IFormMessage[] = []) => (this.messages = messages);

    @action
    public clearMessages = () => (this.messages = []);

    @action
    public setSubmitting = (isSubmitting: boolean) => (this.isSubmitting = isSubmitting);
}
